import APIService from '../api';
export default class RegistrationService extends APIService {
  checkProgress() {
    return this.get('/admin/business/signup-steps');
  }

  updateProgress(id: string, data: object) {
    return this.patch(`/admin/business/signup-steps/${id}`, data);
  }
}
